export class Validation{
    Code!: number;
    Message!: string;
}